// extracted by mini-css-extract-plugin
module.exports = {"languageSelector":"DesktopLanguageSelect_languageSelector__3BL4o"};